export default __webpack_public_path__ + "static/media/yellow_blur_background.ca3d0e6e.jpg";